<template>
  <div class="f-v w-80p w-max-80p of-x-s m-tx4">
    <div class="f h-x8">
      <div :class="optionCellClass"></div>
      <div v-for="(_o, idx) in props.poll.options" :class="rankCellClass">
        <div class="t-18">{{ idx + 1 }}</div>
      </div>
    </div>
    <div v-for="option in order" class="f">
      <div :class="optionCellClass">
        <div class="f-ac f-je p-x2">
          <div class="t text-wrap ta-e">
            <span>{{ option.name }}</span>
            <span
              v-if="option.movie"
              class="material-symbols-outlined t-16 va-m dark-gray pink-hover c-p"
              @click.prevent="openMoviePreview(option.movie)"
            >info</span>
          </div>
        </div>
      </div>
      <div v-for="(_o, rIdx) in props.poll.options" :class="rankCellClass">
        <div :class="rankSelectionClass(option, rIdx)" @click="onClick(option, rIdx)">
          <span
            v-if="cellIsSelected(option, rIdx)"
            class="material-symbols-outlined t-24 onyx"
            :style="{ 'user-select': 'none' }"
          > check_circle </span>
        </div>
      </div>
    </div>
    <input
      v-for="optionId in effectiveRankings"
      type="hidden"
      name="poll_votes[order][]"
      :value="optionId"
    >
  </div>
</template>

<script setup>
  import { ref, computed, watch, onMounted } from 'vue';
  import { useScreens } from '../../composables/screens.js';
  import { useModalStore } from '../../stores/modal_store.js';

  const props = defineProps(['poll']);
  const emit = defineEmits(['updateRankingsAreValid']);
  const modalStore = useModalStore();
  const { isMobile } = useScreens();

  const order = ref([]);
  const rankings = ref(new Array(props.poll.options.length).fill(null));
  const effectiveRankings = computed(() => rankings.value.filter(r => r));
  watch(effectiveRankings, () => {
    emit('updateRankingsAreValid', effectiveRankings.value.length > 0);
  });

  const cellIsSelected = (option, rIdx) => {
    return rankings.value[rIdx] === option.id
  };

  // Classes
  const optionCellClass = computed(() => {
    if (isMobile.value) return 'w-x30 min-w-x30 b-1-gray';
    return 'w-x80 min-w-x80 b-1-gray';
  });
  const rankCellClass = 'w-x8 min-w-x8 f-ac f-jc b-1-gray';
  const rankSelectionClass = (option, rIdx) => {
    const classes = 'h-100p w-x8 f-ac f-jc c-p';
    if (cellIsSelected(option, rIdx)) return `${classes} bg-seafoam-light`;
    return classes;
  };

  // Selection
  const onClick = (option, rIdx) => {
    if (cellIsSelected(option, rIdx)) {
      // If clicking an already made ranking, remove it
      rankings.value[rIdx] = null;
    } else {
      // If clicking an empty square, add the rank
      rankings.value[rIdx] = option.id;
    }
    // Remove any existing ranks for this option
    rankings.value.forEach((r, rIdx2) => {
      if (rIdx2 !== rIdx && r === option.id) rankings.value[rIdx2] = null;
    });
  };

  // Movie Club Add-ons
  const openMoviePreview = (movie) => {
    modalStore.updateModal({
      componentName: 'PollsModalsMoviePreview',
      data: { movie },
    });
  };

  onMounted(() => {
    order.value = props.poll.options.sort(() => Math.random() - 0.5);
  });
</script>